module.exports = __webpack_public_path__ + "img/2 (6).431f1743.jpg";